import type { SVGProps } from 'react'

const WarningTriangleSolid = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 0C8.28267 0 8.56043 0.07264 8.80469 0.210938C9.04903 0.349359 9.25119 0.548894 9.39063 0.788086L15.7861 11.668C15.9264 11.9041 15.9999 12.1726 16 12.4453C16.0001 12.7179 15.9261 12.9855 15.7861 13.2217C15.6461 13.4578 15.4448 13.6545 15.2022 13.791C14.9595 13.9275 14.6837 13.9997 14.4033 14H1.61329C1.33144 14.0025 1.05364 13.9323 0.808598 13.7969C0.563612 13.6615 0.359774 13.4652 0.217777 13.2285C0.0758728 12.9919 0.000650601 12.7231 3.93979e-06 12.4492C-0.00062023 12.1752 0.0729293 11.9053 0.213871 11.668L6.60938 0.788086C6.74882 0.548885 6.95098 0.349363 7.19532 0.210938C7.43958 0.072631 7.71733 3.78996e-06 8 0ZM8 10.5596C7.58594 10.5596 7.25024 10.8956 7.25 11.3096C7.25 11.7238 7.58579 12.0596 8 12.0596H8.00977C8.42398 12.0596 8.75977 11.7238 8.75977 11.3096C8.75954 10.8956 8.42384 10.5596 8.00977 10.5596H8ZM8 3.53027C7.58579 3.53028 7.25 3.86606 7.25 4.28027V8.56055C7.2503 8.97451 7.58597 9.31054 8 9.31055C8.41404 9.31055 8.74971 8.97451 8.75 8.56055V4.28027C8.75 3.86606 8.41422 3.53027 8 3.53027Z"
        fill="currentColor"
        transform="translate(2 3)"
      />
    </svg>
  )
}

export default WarningTriangleSolid
